<script>
import axios from 'axios';
export default {

    data() {
        return {
            showDeleteModel: false,
        }
    },

    methods: {
        async deleteInvitation() {
            try {

                await axios.delete('/api/team/invitations/' + this.record.id);
                window.notify.message('Successfully rescinded invitation', 'success');
                this.$emit('refreshRecords');
                this.showDeleteModel = false;
            }catch(err) {
                window.notify.message(err.toString(), 'error');
            }
        }
    },

    props: {
        record: {
            required: true,
            type: Object
        }
    }

}
</script>
<template>
    <tr>
        <td>{{ record.first_name }}</td>
        <td>{{ record.last_name }}</td>
        <td>{{ record.email }}</td>
        <td>
            <i class="fa fa-times cursor-pointer" @click="showDeleteModel = true"></i>
            <modal
                v-if="showDeleteModel"
                modalWidth="600px"
                @close="showDeleteModel = false">

                <span slot="header">Delete Account Invitation?</span>

                <slot slot="body">
                    <p>Are you sure you want to remove this invitation?</p>
                    <button class="inputbutton1 rounded" @click="deleteInvitation">
                        Delete
                    </button>
                    <button class="inputbutton1 rounded" @click="showDeleteModel = false">
                        Cancel
                    </button>
                </slot>
            </modal>
        </td>
    </tr>
</template>
